import { render, staticRenderFns } from "./SitemapNode.vue?vue&type=template&id=a8509554"
import script from "./SitemapNode.vue?vue&type=script&lang=js"
export * from "./SitemapNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports